export default {
    keycloakAuthURL:
        process.env.REACT_APP_KEYCLOAK_AUTH_URL || 'https://stg-auth.streamsix.com/auth',
    keycloakRealm: process.env.REACT_APP_REALM || 'Users',
    keycloakClientId: process.env.REACT_APP_CLIENT_ID || 'tp-dev',

    depotServiceURL: process.env.REACT_APP_DEPOT_SERVICE_URL || 'http:///localhost:8001',
    leaderboardServiceURL: process.env.REACT_APP_LEADERBOARD_SERVICE_URL || 'http://localhost:8007',
    inventoryServiceURL:
        process.env.REACT_APP_INVENTORY_SERVICE_URL ||
        'https://sagames-dev-api.streamsix.com/inventory-service',
    socialServiceURL: process.env.REACT_APP_SOCIAL_SERVICE_URL || 'http://localhost:8005',
    lobbyServiceURL: process.env.REACT_APP_LOBBY_SERVICE_URL || 'http://localhost:8004',
    licenseServiceURL: process.env.REACT_APP_LICENSE_SERVICE_URL || 'http:///localhost:8009',
    entityManagerURL: process.env.REACT_APP_ENTITY_MANAGER_URL || 'http:///localhost:8008',

    docsURL:
        process.env.REACT_APP_DOCS_URL ||
        'http://streamsix-devportal-dev-hostingbucket.s3-website-us-east-1.amazonaws.com/docs/',

    features: {
        leaderboards: process.env.REACT_APP_FEATURE_FLAG_LEADERBOARDS || false,
        runningGames: process.env.REACT_APP_FEATURE_FLAG_RUNNING_GAMES || false,
        inventory: process.env.REACT_APP_FEATURE_FLAG_INVENTORY || false,
    },
};
